import React from 'react'

import CompanyCompassCopyLinkButton from '@/components/compass/CompanyCompassCopyLinkButton'
import CompanyCompassLinkInput from '@/components/compass/CompanyCompassLinkInput'
import CompassGlobalLinkTooltip from '@/components/compass/CompassGlobalLinkTooltip'
import { Heading } from '@/components/ui/heading'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import useMinWidth from '@/hooks/useMinWidth'
import { cn } from '@/lib/utils'

type Props = Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>

const CompanyCompassLink: React.FC<Props> = ({ className, ...props }) => {
  const currentCompany = useCurrentCompanyOrFail()
  const isMinWidthMd = useMinWidth('md')

  return (
    <section
      className={cn(
        `flex w-full flex-col flex-wrap gap-2 md:w-auto md:flex-row
        md:items-center md:gap-4`,
        className,
      )}
      {...props}
    >
      <div className="relative flex items-center">
        <CompassGlobalLinkTooltip />

        <Heading
          size={4}
          className="mb-0 inline-block grow font-bold text-black"
          style={{
            fontSize: '14px',
            marginLeft: '5px',
          }}
        >
          {currentCompany.presentationName}'s global link:
        </Heading>
      </div>

      <div
        className="flex w-full flex-row items-center gap-2 md:w-auto
          md:flex-wrap"
      >
        <CompanyCompassLinkInput
          style={{ width: isMinWidthMd ? '300px' : undefined }}
        />

        <CompanyCompassCopyLinkButton />
      </div>
    </section>
  )
}

export default CompanyCompassLink
